import { memo } from 'react';
import styles from '../../styles/WeaponPlate.module.css';
import { fmtWS, parseWS, wsDescription } from '../../engine/weaponSpecials';

interface WeaponSpecialChipsProps {
  specialRules: string[];
  /** Show at most this many, with a "+N" chip for the rest. */
  limit?: number;
}

/**
 * Every special rule the weapon has, as chips, each explaining itself.
 *
 * The old grid rendered `specialRules.slice(0, 2)` followed by a literal
 * "..." - so a bolter with Tearing, Storm, Reliable and Proven(3) showed
 * two of them and no way to see the rest without opening the editor. All
 * 43 specials carry a rules blurb in WS_LIST; `title` is where it goes.
 */
function WeaponSpecialChips({ specialRules, limit }: WeaponSpecialChipsProps) {
  if (!specialRules?.length) return null;
  const shown = limit ? specialRules.slice(0, limit) : specialRules;
  const hidden = specialRules.length - shown.length;

  return (
    <div className={styles.specials} data-testid="weapon-specials">
      {shown.map((rule, i) => (
        <span key={i} className={styles.special} title={wsDescription(parseWS(rule).id)}>
          {fmtWS(rule)}
        </span>
      ))}
      {hidden > 0 && (
        <span className={styles.special} title={specialRules.slice(shown.length).map(fmtWS).join(', ')}>
          +{hidden}
        </span>
      )}
    </div>
  );
}

export default memo(WeaponSpecialChips);
